import _ from 'lodash';
import fetchWithCache from './fetchWithCache';
import { translate } from '../utils/translate/translations';

const defaultResponse = () => ({
  formulaPricing: false,
  disclaimer: translate('byo.page.general.disclaimer.msrp.1'),
  simpleDisclaimer: translate('byo.page.general.disclaimer.msrp.simple'),
  value: 0,
  lines: [],
  total: 0,
});

const normalizeResponse = (data) => {
  const disclaimer =
    _.get(data, 'summary.disclaimer') ||
    _.get(data, 'individual.disclaimers.summary') ||
    '';
  const simpleDisclaimer =
    _.get(data, 'individual.disclaimers.initial') ||
    translate('byo.page.general.disclaimer.msrp.simple');
  const value = _.get(data, 'summary.incentive') || 0;
  const lines = _.get(data, 'individual.incentives') || [];
  const total = lines.reduce(function (total, line) {
    return total + line.value;
  }, 0);
  return {
    formulaPricing: _.get(data, 'formulaPricing'),
    disclaimer,
    simpleDisclaimer,
    value,
    lines,
    total,
  };
};

const fetchIncentives = ({
  v3ServicesPath,
  modelPath,
  styleId,
  postalCode,
  rpos = [],
}) => {
  const query = `?rpo=${rpos.join(',')}`;
  const url = `${v3ServicesPath}/incentives/${modelPath}/${styleId}/${postalCode}${query}`;

  return fetchWithCache(url).then(normalizeResponse).catch(defaultResponse);
};

export default fetchIncentives;
